import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

import router from './pages/router' // router

/* swiper関連 */ 
import VueAwesomeSwiper from 'vue-awesome-swiper'
// If you use Swiper 6.0.0 or higher
import 'swiper/swiper-bundle.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

import Swiper,{ Navigation, Pagination, Scrollbar, Mousewheel, Autoplay } from 'swiper';
// If you use Swiper 6.0.0 or higher
Swiper.use([Navigation, Pagination, Scrollbar, Mousewheel, Autoplay]);

/* axios関連 */
import axios from 'axios' //追記
import VueAxios from 'vue-axios' //追記
axios.defaults.xsrfCookieName = 'csrftoken' // csrf対策
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN" // csrf対策
axios.defaults.headers.get['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.get['Access-Control-Allow-Origin'] = true;
axios.defaults.headers.get['Access-Control-Allow-Methods'] =  'GET';
axios.defaults.crossDomain = true;
Vue.use(VueAxios, axios) //追記
Vue.config.devtools = true;
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
